<template>
    <div :id="page_slug">

        <div class="crumbs-bar">
            <el-row>
                <el-col :span="12">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ name: 'OrderList' }">Orders</el-breadcrumb-item>
                        <el-breadcrumb-item>View</el-breadcrumb-item>
                    </el-breadcrumb>     
                    
                    <!-- 
                    <template>
                        <el-alert
                        v-if="overdue"
                        title="warning alert"
                        type="warning"
                        description="more text description"
                        show-icon>
                        </el-alert>
                    </template> 
                    -->
                </el-col>      
            </el-row>
        </div>

        <el-row :gutter="30" class="row-spacer">
            <el-col :span="8" :md="8" :xs="24" :sm="24">
                <el-card 
                    v-loading="loading.order"
                    shadow="never"
                    body-style="{padding: '20px'}">

                    <div slot="header" class="clearfix">
                        <span class="title-text">Order Details</span>
                    </div>
                    <span><strong>Order: </strong> #{{ order.id }}<br></span>
                    <span><strong>Date: </strong> {{ order.created_at | moment(config.date_format_compact) }}<br></span>
                    <span><strong>Placed by: </strong> {{ order.customer_first_name }} {{ order.customer_last_name }}<br></span>
                    <span v-if="order.purchase_order_number"><strong>Purchase Order: </strong> {{ order.purchase_order_number }}<br></span>
                    <span v-if="order.payment_methods"><strong>Payment Method: </strong> {{ order.payment_methods.name }}<br></span>
                    <span v-if="order.shipping_method"><strong>Shipping Method: </strong> {{ order.shipping_method.name }}<br></span>
                    <br>
                    <span v-if="order.status"><strong>Order Status: </strong><el-tag :type="order.status.label_color">{{order.status.name}}</el-tag></span>

                </el-card>
            </el-col>

            <el-col :span="8" :md="8" :xs="24" :sm="24">
                <el-card 
                    v-loading="loading.order"
                    shadow="never"
                    body-style="{padding: '20px'}">

                    <div slot="header" class="clearfix">
                        <span class="title-text">Billing Address</span>
                    </div>
                    <span v-if="order.company_name"><strong>{{ order.company_name }}</strong><br></span>
                    <span v-if="order.billing_address_1">{{ order.billing_address_1 }}<br></span>
                    <span v-if="order.billing_address_2">{{ order.billing_address_2 }}<br></span>
                    <span v-if="order.billing_address_3">{{ order.billing_address_3 }}<br></span>
                    <span v-if="order.billing_city">{{ order.billing_city }}<br></span>
                    <span v-if="order.billing_state != 'null', ''">{{ order.billing_state }}<br></span>
                    <span v-if="order.billing_country">{{ order.billing_country }}<br></span>
                    <span v-if="order.billling_zip != 'null', ''">{{ order.billing_zip }}<br></span>
                    <br>
                    <span v-if="order.billing_telephone != 'null'">Tel: {{ order.billing_telephone }}<br></span>
                    <span v-if="order.billing_mobile != 'null', ''">Mob: {{ order.billing_mobile }}<br></span>

                </el-card>
            </el-col>

            <el-col :span="8" :md="8" :xs="24" :sm="24">
                <el-card 
                    v-loading="loading.order"
                    shadow="never"
                    body-style="{padding: '20px'}">

                    <div slot="header" class="clearfix">
                        <span class="title-text">Shipping Address</span>
                    </div>
                    <span v-if="order.company_name"><strong>{{ order.company_name }}</strong><br></span>
                    <span v-if="order.shipping_address_1">{{ order.shipping_address_1 }}<br></span>
                    <span v-if="order.shipping_address_2">{{ order.shipping_address_2 }}<br></span>
                    <span v-if="order.shipping_address_3">{{ order.shipping_address_3 }}<br></span>
                    <span v-if="order.shipping_city">{{ order.shipping_city }}<br></span>
                    <span v-if="order.shipping_state != 'null', ''">{{ order.shipping_state }}<br></span>
                    <span v-if="order.shipping_country">{{ order.shipping_country }}<br></span>
                    <span v-if="order.billling_zip != 'null', ''">{{ order.shipping_zip }}<br></span>
                    <br>
                    <span v-if="order.shipping_telephone != 'null'">Tel: {{ order.shipping_telephone }}<br></span>
                    <span v-if="order.shipping_mobile != 'null', ''">Mob: {{ order.shipping_mobile }}<br></span>

                </el-card>
            </el-col>    
        </el-row>

        <el-row class="row-spacer">
            <el-col :span="24" :md="24" :xs="24" :sm="24">
                <el-card 
                    shadow="never"
                    body-style="{padding: '20px'}">

                    <div slot="header" class="clearfix">
                        <span class="title-text">Order Items <Address></Address></span>
                    </div>
                    
                    <el-table
                        v-loading="loading.order"
                        :data="order.orders_details"
                        style="width: 100%">

                        <el-table-column
                            label="Image"
                            min-width="100">
                            <template slot-scope="scope">
                                <img :src="scope.row.artwork_path" class="table-thumb">
                            </template>
                        </el-table-column>

                        <el-table-column
                            prop="product_name"
                            label="Product"
                            min-width="200">
                            <template slot-scope="scope">
                                {{scope.row.product_name}}<br>
                                <small>SKU: {{scope.row.product_sku}}</small><br>
                                <span v-if="scope.row.product_notes != 'null', ''">Notes: {{scope.row.product_notes}}<br></span>
                                <span v-if="scope.row.PDF_path"><a class="el-button el-button--text el-button--small" v-bind:href="scope.row.PDF_path" download target="_blank">Download Artwork</a></span>
                            </template> 
                        </el-table-column>

                        <!-- <el-table-column
                            prop="unit_price"
                            label="Unit Price"
                            min-width="100">
                            <template slot-scope="scope">
                                {{scope.row.unit_price | toCurrency}}
                            </template>
                        </el-table-column> -->

                        <el-table-column
                            prop="options"
                            label="Options">
                            <template slot-scope="scope">
                                {{displayOptions(scope.row.options)}}
                            </template>
                        </el-table-column>

                        <el-table-column
                            prop="quantity"
                            label="Quantity"
                            min-width="100">
                        </el-table-column>

                        <el-table-column
                            prop="total_price"
                            label="Total"
                            min-width="100">
                            <template slot-scope="scope">
                                {{scope.row.total_price | toCurrency}}
                            </template>
                        </el-table-column>

                        <!-- <el-table-column
                            prop="tracking_number"
                            label="Tracking"
                            min-width="100">
                            <template slot-scope="scope">
                                <el-button 
                                    v-if="scope.row.shipping_method !=null" 
                                    type="default" 
                                    size="small" 
                                    @click="trackItem(scope.row.shipping_method.tracking_url + scope.row.tracking_number)">
                                    Track Item
                                </el-button>
                            </template>
                        </el-table-column> -->

                        <!-- <el-table-column
                            prop="status"
                            label="Status">
                            <template slot-scope="scope">
                                <el-tag :type="scope.row.status.label_color">{{scope.row.status.name}}</el-tag>
                            </template>
                        </el-table-column> -->

                        <el-table-column
                            width="150"
                            prop="status"
                            label="Status">
                            <template slot-scope="scope">
                                <el-select 
                                    v-model="scope.row.order_status_id" 
                                    @change="updateStatus(scope.row)"
                                    placeholder="Select Here">

                                    <el-option
                                        v-for="item in status_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>

                        <el-table-column
                            prop="due_date"
                            label="Due Date">
                            <template slot-scope="scope">
                                <el-tag type="warning" v-if="daysOverdue(scope.row) === false" >{{scope.row.due_date | moment(config.date_format_compact)}}</el-tag>
                                <el-tag type="gray" v-if="daysOverdue(scope.row) === true" >{{scope.row.due_date | moment(config.date_format_compact)}}</el-tag>
                                
                            </template> 
                        </el-table-column>

                    </el-table>

                </el-card>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="8" :offset="16" :md="8" :xs="24" :sm="24">
                <el-card 
                    v-loading="loading.order"
                    shadow="never"
                    body-style="{padding: '20px'}">

                    <strong>Goods Subtotal:</strong> {{ order.goods_subtotal | toCurrency }}<br>
                    <strong>Goods VAT:</strong> {{ order.goods_tax | toCurrency }}<br>
                    <strong>Shipping:</strong> {{ order.shipping_subtotal | toCurrency }}<br>
                    <strong>Shipping VAT:</strong> {{ order.shipping_tax | toCurrency}}<br>
                    <hr>
                    <h3>Total: {{ order.cart_total | toCurrency}}</h3>

                </el-card>
            </el-col>
        </el-row>

        <pre>{{$data}}</pre>
    </div>
</template>

<style scope>
    .inner-padding {
        padding:20px;
    }
    .table-thumb {
        margin: 10px;
        width:120px;
        height:auto;
    }
    .pull-right {
        float: right;
    }
</style>

<script>
    import Config from '@/store/Config.js';
    import moment from 'moment';

    export default {
        data: function() {
            return { 
                page_alias: 'View Order',
                page_slug: 'view-order',
                label_position: 'top',

                loading: {
                    order: true
                },

                config: Config.config,

                status_list: [
                    {"id": 1, "name": "New"},
                    {"id": 2, "name": "Processing"},
                    {"id": 3, "name": "Shipped"},
                    {"id": 4, "name": "Completed"},
                    {"id": 5, "name": "Cancelled"},
                ],

                order: {
                    customer_first_name: '',
                    customer_last_name: '',
                    customer_email: '',
                    vat_number: '',
                    billing_address_1: '',
                    billing_address_2: '',
                    billing_address_3: '',
                    billing_city: '',
                    billing_state: '',
                    billing_country: '',
                    billing_zip: '',
                    billing_telephone: '',
                    billing_mobile: '',
                    company_name: '',
                    shipping_address_1: '',
                    shipping_address_2: '',
                    shipping_address_3: '',
                    shipping_city: '',
                    shipping_state: '',
                    shipping_country: '',
                    shipping_zip: '',
                    shipping_telephone: '',
                    shipping_mobile: '',
                    purchase_order_number: ''
                }
            };
        },

        mounted: function() {
            const me = this;
            me.getOrder();
        },

        methods: {
            displayOptions: function(options) {
                var output = '';
                for(var i = 0; i < options.length; i++) {
                    output += '[' + options[i].name + ': ' + options[i].quantity + ']';
                }
                
                return output;
            },

            getOrder: function() {
                console.log('Get Order Function');
                const me = this;
                me.$http.get(me.config.api + 'order/{id}', {params: {id : me.$route.params.id}}).then(
                    response => {
                    console.log('Success Getting Data')  
                    console.log(response.status);
                    console.log(response.statusText);
                    me.order = response.body.data;

                    for(var i = 0; i < me.order.orders_details.length; i++) {
                        if(me.order.orders_details[i].options.length >= 1) {
                            me.order.orders_details[i].options = JSON.parse(me.order.orders_details[i].options);
                        }
                    }

                    me.loading.order = false;
                }, response => {
                    console.log('Error Getting Data');
                    console.log(response.status);
                    console.log(response.statusText);
                    me.loading.order = false;
                });
            },

            updateStatus: function(order_item) {
                console.log('Update Status Function');
                const me = this;

                me.$confirm('This will change the status - Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    /* 
                    Old Way:
                    order_item.options = JSON.stringify(order_item.options); 

                    JavaScript passes values by reference meaning when you stringify
                    order_item.options you're stringifying edited_line_item_product which 
                    in turn is breaking the list of options in the dialog causing
                    1000+ errors when this method is hit

                    Lodash's cloneDeep method makes the varaible order_item_clone without 
                    referencing order_item i.e. changing order_item_clone will not change
                    order_item breaking the options
                    */

                    var order_item_clone = _.cloneDeep(order_item);
                    order_item_clone.options = JSON.stringify(order_item.options);

                    me.$http.put(me.config.api + 'order/{id}/orderDetails/{orders_details_id}', order_item_clone, {params: {id : me.$route.params.id, orders_details_id: order_item.id}}).then(
                        response => {
                        console.log('Success Putting Data')  
                        console.log(response.status);
                        console.log(response.statusText);
                        me.getOrder();
                        me.$notify({
                            title: 'Success',
                            message: 'The Status Was Updated',
                            type: 'success',
                        });
                    }, response => {
                        console.log('Error Putting Data');
                        console.log(response.status);
                        console.log(response.statusText);
                    });  
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Update Canceled'
                    });          
                });
            },

            daysOverdue: function(order_item) {
                console.log('Days Overdue Function');

                // var formatted_created_at = new Date(order_item.created_at);
                // var formatted_due_date = new Date(order_item.due_date);
                // var formatted_today = new Date();

                // var millisecond_difference = formatted_today.getTime() - formatted_due_date.getTime();

                // console.log('millisecond_difference', millisecond_difference);

                // var day_difference = Math.ceil(millisecond_difference / (1000 * 3600 * 24)); 

                // if(day_difference < order_item.turnaround_time) {
                //     return 'Overdue By ' + day_difference + ' Days';
                // } else {
                //     return 'Due In ' + Math.abs(day_difference) + ' Days';
                // }


                // Is the order item completed

                var today = Date(Date.now());

                if (order_item.order_status_id == 3) {
                    return true;
                } else if (order_item.order_status_id != 3 && order_item.due_date < today) {
                    return false;
                }


            }

            // daysOverdue: function(order_item) {
            //    const me = this;
            //     console.log('set order status function');

            //    var formatted_created_at = new Date(order_item.created_at);
            //     console.log('Created At Date: ' + formatted_created_at);

            //    var formatted_today = new Date();
            //    console.log('Date: ' + formatted_today);
 
 
            //     var timeDiff = Math.abs(formatted_today.getTime() - formatted_created_at.getTime());
            //     console.log(timeDiff);

            //     var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)); 
            //     console.log('day difference: ' + diffDays);

            //     if(diffDays > order_item.turnaround_time) {
            //        return 'Overdue By ' + diffDays + ' Days';
            //    } else {
            //        return 'On Time';
            //     }
            // }
       }



        
     
    }
</script>


// WEBPACK FOOTER //
// src/pages/orders/OrderView.vue